const Sections = {
  App: '/app',
  Public: '/',
};

export default Sections;